import * as React from 'react';
import { get } from 'lodash';
import { default as RenderToggle } from 'material-ui/Toggle';

import { AutoCompleteField, AutoComplete, InputField, Input } from '@components/form';

const AutoCompleteToggle: React.SFC<any> = ({
  items,
  toggled,
  inputName,
  autoCompleteName,
  label,
  onToggle,
  onDelete,
  onChange,
  toggleDisabled,
  sorting
}) => (
  <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
    <div style={{ width: '100%' }}>
      {toggled ? (
        <InputField id={inputName} name={inputName} component={Input} label={`${label} - vlastní`} />
      ) : (
        <AutoCompleteField
          id={autoCompleteName}
          name={autoCompleteName}
          component={AutoComplete}
          label={label}
          items={items}
          labelFunction={o => get(o, 'name')}
          valueFunction={o => get(o, 'id')}
          onDelete={onDelete}
          onChange={onChange}
          fullWidth={true}
          arrowstyle={{ position: 'absolute', right: 0, top: 36, color: '#bbb' }}
          sorting={sorting}
        />
      )}
    </div>
    <div>
      <RenderToggle toggled={toggled} onToggle={onToggle} disabled={toggleDisabled} />
    </div>
  </div>
);

export default AutoCompleteToggle;



// WEBPACK FOOTER //
// ./src/components/form/AutoCompleteToggle/AutoCompleteToggle.tsx